import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, TextField, Button } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/modifierLeTitre.css';

export const ModifierLeNom = (props) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const { modifyTitre, setModifyTitre } = props;

    const formik = useFormik({
        initialValues: {
            name: machineDetailsData?.name || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`machine/machine_name/${id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier le nom de la machine' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, name: response.data.name }));
                    setModifyTitre(false);
                }
            } catch (error) {
                console.error('Error updating machine:', error);
                CustomErrorLogger(error, 'Error updating machine name in ModifierLeNom');
            }
        },
    });

    const { handleSubmit, values, handleBlur, touched, errors, handleChange } = formik;

    return (
        <Dialog open={modifyTitre} fullWidth>
            <Box onClick={() => setModifyTitre(false)} className='modifierTitre_icon_text'>
                <Typography className='modifierTitre_title'>{t('Modifier le nom de la machine')}</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierTitre_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='modifiertitre_dialog_content' >
                    <Box className="modifierTitre_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="modifierTitreInputTitle">{t('Nom de la machine')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                            className={values.name ? 'modifiertitre_InputField filledField' : 'modifiertitre_InputField'}
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='modifierTitre_dialog_actions'>
                    <Button className='modifierTitre_button_annuler' onClick={() => setModifyTitre(false)}>{t('Annuler')}</Button>
                    <Button className='modifierTitre_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};